import { SettingsPermissions } from "@redotech/account-common/permissions";
import type {
  SettingAccess,
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ReturnsBillingGeneralFlatTeamSettingGroupId =
  "returns_billing_general.subscription";

const returnsBillingGeneralOwner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.returns.subscriptionBilling",
  product: "billing",
};

const returnsBillingGeneralRisk: SettingRisk = {
  level: "low",
  reason:
    "Read-only view of the current returns subscription plan; nothing on the page changes billing.",
};

// The billing page is viewable with VIEW_BILLING alone, so reading must not
// demand the stricter write permission.
const returnsBillingGeneralAccess: SettingAccess = {
  read: {
    minVisibility: "merchant",
    permission: SettingsPermissions.VIEW_BILLING,
  },
  write: {
    mode: "grants",
    grants: [
      {
        minVisibility: "merchant",
        method: "direct",
        permission: SettingsPermissions.SET_BILLING_SETTINGS,
      },
    ],
  },
};

export const ReturnsBillingGeneralFlatTeamSettingGroups = [
  {
    id: "returns_billing_general.subscription",
    title: "Returns subscription",
    description: "The current returns subscription plan.",
    productArea: "billing",
    access: returnsBillingGeneralAccess,
    owner: returnsBillingGeneralOwner,
    risk: returnsBillingGeneralRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "billing?product=returns" },
    synonyms: [
      "returns subscription",
      "subscription",
      "returns plan",
      "returns billing",
      "returns invoice",
    ],
    availability: {
      conditions: [
        { type: "evaluator", evaluator: "returns.subscriptionBillingEnabled" },
      ],
      unavailableBehavior: "hidden",
      reason:
        "Only available once returns subscription billing is enabled for the team; the page renders a plan summary instead, with no subscription section to link to.",
    },
  },
] as const satisfies readonly SettingGroupDefinition<ReturnsBillingGeneralFlatTeamSettingGroupId>[];
